export default __webpack_public_path__ + "/dist/images/Importers-Distributors-video.mp4";